let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5sFoQ")).then(() => parcelRequire('ikxk8'));